import { TLocalStorage } from "@/Instructure/types/localStorage";

export class LocalStorageService {

    read(name: TLocalStorage): any | null {
        try {
            const result = localStorage.getItem(name);
            return result !== null ? JSON.parse(result) : null;
        } catch (e) {
            return null;
        }
    }

    write(name: TLocalStorage, value: any): any | null {
        try {
            localStorage.setItem(name, JSON.stringify(value));
            return value;
        } catch (e) {
            return null
        }
    }

    deleteItem(name: TLocalStorage): void {
        localStorage.removeItem(name);
    }

    destroyAllLocalStorage() {

        localStorage.clear();
    }

}